import Image from 'next/image'
import { CHANGELOG_QUERYResult, POST_QUERYResult } from '../../../sanity.types'
import { urlFor } from '@/sanity/lib/image'
import { PortableText } from 'next-sanity'
import { portableTextComponents } from './PortableTextComponents'

type AuthorType = NonNullable<
  POST_QUERYResult | CHANGELOG_QUERYResult
>['authors']

export function AuthorsMini({ authors }: { authors: AuthorType }) {
  if (!authors) return null

  return (
    <ul
      // className={clsx('-mx-5 -mt-6 flex flex-wrap text-sm leading-6 border')}
      className="!my-0 flex w-max flex-wrap gap-10 !px-0"
    >
      {authors.map((author) => (
        <li
          key={author?.title}
          className="!mx-0 !my-0 flex max-h-max w-max items-center !px-0 font-medium"
        >
          {author?.image?.asset?._ref && (
            <Image
              src={urlFor(author.image.asset._ref).url()}
              className="!my-0 mr-3 h-10 w-10 rounded-full"
              width={1000}
              height={1000}
              alt={author?.name || ''}
            />
          )}
          <div className="leading-4">
            <div className="text-md text-slate-200">{author?.name}</div>
            <div className="text-sm text-sky-400">{author?.title}</div>
          </div>
        </li>
      ))}
    </ul>
  )
}

export function AuthorsFull({ authors }: { authors: AuthorType }) {
  if (!authors) return null

  return (
    <div className="mt-12 flex flex-wrap gap-y-2">
      {authors.map((author) => (
        <div
          key={author?.title}
          className="flex w-full rounded-lg border border-gray-700 bg-gray-800 px-4 py-4 shadow-lg md:px-8"
        >
          <div className="flex flex-wrap gap-x-4 gap-y-4 md:flex-nowrap">
            {author?.image?.asset?._ref && (
              <Image
                src={urlFor(author.image.asset._ref).url()}
                className="h-20 w-20 rounded-full"
                width={1000}
                height={1000}
                alt={author?.name || ''}
              />
            )}
            <div>
              <div className="text-xl font-medium text-slate-200">
                {author?.name}
              </div>
              <div className="text-md font-semibold text-sky-400">
                {author?.title}
              </div>
              <div className="text-md mt-3 text-slate-200">
                {author?.bio ? (
                  <PortableText
                    value={author?.bio}
                    components={portableTextComponents}
                  />
                ) : null}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
